<template>
  <div>
    <b-container fluid class="page">
      <b-row class="firstRow">
        <b-col cols="12">
        <div v-html="policy" class="policy"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
const axios = require('axios')
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
      policy: '<b>Loading</b>'
    }
  },
  mounted: function () {
    axios.get('https://www.iubenda.com/api/privacy-policy/89822807/no-markup')
      .then((result) => {
        this.policy = result.data.content
        console.log(this.policy)
      })
  }
}
</script>
<style scoped>
  .firstRow{margin:}
  .page{margin: 2rem 3rem; width: 90%}
</style>
